import { StandardDivider } from '@brandfolder/react';
import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

import { SettingsTypeface } from '@components/aside/settings/settings-typeface';

import { SettingsBackgroundColor } from './settings-background-color';
import { SettingsCustomCss } from './settings-custom-css';
import { SettingsFavicon } from './settings-favicon';
import { SettingsHeaderCdnUrl } from './settings-header-cdn-url';
import { SettingsManageBrandguide } from './settings-manage-brandguide';
import { SettingsManageUsers } from './settings-manage-users';
import { SettingsTextColor } from './settings-text-color';

type GlobalSettingsProps = HTMLAttributes<HTMLDivElement>;

const UnstyledGlobalSettings: FunctionComponent<GlobalSettingsProps> = (props) => {
  return (
    <div {...props}>
      <SettingsBackgroundColor />
      <SettingsTextColor />
      <SettingsTypeface />
      <SettingsFavicon />
      <SettingsHeaderCdnUrl />
      <StandardDivider />
      <SettingsCustomCss />
      <StandardDivider />
      <SettingsManageUsers />
      <StandardDivider />
      <SettingsManageBrandguide />
    </div>
  );
};

const StyledGlobalSettings = styled(UnstyledGlobalSettings)`
  .global-settings__wrapper {
    padding: 0px 20px;
  }

  .bf-divider__standard {
    margin: 24px 0;
  }
`;

export const GlobalSettings: FunctionComponent<GlobalSettingsProps> = (props) => {
  return <StyledGlobalSettings {...props} />;
};
